/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMacropointControl.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/macropoint-control";

export class AutogenModelMacropointControl<RowType extends ModelRow> extends Endpoint<RowType, RowMacropointControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMacropointControl extends ModelRow<RowMacropointControlFields> {
	constructor(values?: Partial<RowMacropointControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMacropointControlFields {
	account_id: string;
	company_id: string;
	error_email: string;
	events_interval: number;
	events_sent: Date;
	id: number;
	is_active: string;
	passwd: string;
	positions_interval: number;
	positions_sent: Date;
	requestor_load_id: string;
	vendor_url: string;
}

